/**
 * Web Style Import
 *
 */

import './style/dnb-space.scss'
